module.exports = __webpack_public_path__ + "img/male.55bc77c6.jpg";